<ng-select
  #ngSelect
  appendTo="body"
  [ngClass]="classList"
  (change)="onChange($event)"
  (open)="onOpen($event)"
  (clear)="onClear($event)"
  [placeholder]="placeholder"
  [items]="items"
  [multiple]="multiple"
  [closeOnSelect]="closeOnSelect"
  [searchable]="true"
  [loading]="loading"
  [(ngModel)]="value"
  [minTermLength]="0"
  [disabled]="isDisabled"
  [compareWith]="compareFn"
  [typeahead]="quickSearchTermInput$"
  loadingText="{{ 'CA::Loading' | abpLocalization }}..."
  bindLabel="name">
  >
  <ng-template *ngIf="multiple" ng-multi-label-tmp let-items="items" let-clear="clear">
    <div class="ng-value" *ngIf="items.length === 1">
      <span class="ng-value-label d-flex flex-row justify-content-start align-items-center">
        <span class="truncate-text" [ngbTooltip]="items[0].name">
          {{ items[0].name }}
        </span>
      </span>
    </div>
    <div class="ng-value" *ngIf="items.length > 1">
      <span class="ng-value-label">
        {{ 'User::SelectedRolesWithCount' | abpLocalization : items.length }}
      </span>
    </div>
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    <div
      class="reason-option d-flex align-items-center"
      [ngbTooltip]="item.name"
      container="body"
      showTooltipIfTruncated>
      <input *ngIf="multiple" type="checkbox" [checked]="isSelected(item)" class="me-2" />
      {{ item.name }}
    </div>
  </ng-template>
  <ng-template *ngIf="!removePagination" ng-footer-tmp>
    <div class="w-100 d-flex d-flex flex-row justify-content-start align-items-center">
      <mat-paginator
        class="d-flex flex-row justify-content-row"
        style="flex: 0 0 350px"
        [length]="totalCount"
        [pageSize]="itemsPerPage"
        [pageIndex]="pageIndex"
        [hidePageSize]="true"
        [showFirstLastButtons]="true"
        (page)="onPageChange($event)"></mat-paginator>
    </div>
  </ng-template>
</ng-select>
